import { render, staticRenderFns } from "./FilterSearch.vue?vue&type=template&id=24e8d806"
import script from "./FilterSearch.vue?vue&type=script&lang=ts"
export * from "./FilterSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports